export default __webpack_public_path__ + "static/media/FondoGris.1e086fc4.jpg";